import React from 'react';
import classNames from 'classnames';
import img1 from '../../images/terms.svg';
import img2 from '../../images/salesdates.svg';
import img3 from '../../images/rules.svg';
import './styles.scss';

const MarketAreas = props => {
    return (
        <section className={classNames({
            'market-areas': true,
            ...props.modifiers
        })}>
            {props.heading &&
                <header className="market-areas__header">
                    <h2 className="market-areas__heading">{props.heading}</h2>
                </header>
            }
            
            <div className="market-areas__col-container">
                <div className="market-areas__col">
                    <div className="market-areas__area-img">
                        <img src={img2} alt="" />
                    </div>
                    <h2 className="market-areas__area-heading">Försäljningsdagar</h2>
                    <p className="market-areas__area-text">
                        Ladda ner vår pdf med sammanställning av försäljningsdagar 2023 - 2026.
                    </p>
                    <a className="market-areas__download" href="https://dabas.blob.core.windows.net/delfinext-statistics/Fsg-dgr%202023-2026.pdf" download="Försäljningsdagar 2023-2026.pdf" target="_blank" rel="noreferrer">Ladda ned pdf</a>
                </div>
                <div className="market-areas__col">
                    <div className="market-areas__area-img">
                        <img src={img1} alt="" />
                    </div>
                    <h2 className="market-areas__area-heading">Allmän information</h2>
                    <p className="market-areas__area-text">
                        Allmän information gällande försäljningsstatistiken från Delfi Marknadspartner AB.
                    </p>
                    <a className="market-areas__download" href="https://dabas.blob.core.windows.net/delfinext-statistics/Delfi Marknadspartner - Allmänna villkor Statistik 2022.pdf" download="Delfi Marknadspartner - Allmänna villkor Statistik 2022.pdf" target="_blank" rel="noreferrer">Ladda ned pdf</a>
                </div>
                <div className="market-areas__col">
                    <div className="market-areas__area-img">
                        <img src={img3} alt="" />
                    </div>
                    <h2 className="market-areas__area-heading">Publiceringsregler</h2>
                    <p className="market-areas__area-text">
                        Publiceringsregler för försäljningsstatistik från Delfi Marknadspartner AB.
                    </p>
                    <a className="market-areas__download" href="https://dabas.blob.core.windows.net/delfinext-statistics/Delfi Marknadspartner - Publiceringsregler 2022.pdf" download="Delfi Marknadspartner - Publiceringsregler 2022.pdf" target="_blank" rel="noreferrer">Ladda ned pdf</a>
                </div>
            </div>
        </section>
    );
};

export default MarketAreas;